export function transformValueToFullPercentage(value: number): number {
  if (value < 0.01) {
    return Number(value.toFixed(3));
  }
  if (value < 0.1) {
    return Number(value.toFixed(2));
  }
  if (value < 1) {
    return Number(value.toFixed(1));
  }

  return Number(value.toFixed(0));
}
